import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Modal } from 'bootstrap';
import { ModalInfoComponent } from '../../02-organisms/modal-info/modal-info.component';
import { ApiService } from 'src/app/Services/Api/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  modal: Modal | undefined;
  images: string[] = [];

  constructor(
    private modalService: NgbModal,
    private _apiService: ApiService) { }

  ngOnInit(): void {
    this.images = [];
    this._apiService.get('modal').then((data: any) => {
      if (data['modals'].length > 0) {
        this.images = [
          ...data.modals.map(
            (modal: any) =>
              `${environment.backendURL}/publico/imagenes/9/${modal.nombre}`
          ),
        ];
        this.openModal();
      }
    });
  }

  openModal() {
    const modalRef = this.modalService.open(ModalInfoComponent);
    modalRef.componentInstance.images = this.images;
  }
}
